import { useEffect, useState } from "react";
import { X, Download, Smartphone } from "lucide-react";

const KEY = "zafara_smartbanner_dismissed";
const DISMISS_DAYS = 7;

/**
 * Sticky top-of-page banner shown ONLY on mobile devices (< lg breakpoint).
 * Redirects to the smart /api/download link (auto App Store / Play Store).
 * Dismissible; hidden for 7 days after user closes it.
 */
export const AppDownloadBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    // Only show on likely-mobile widths
    const isMobile = window.innerWidth < 1024 && /iPhone|iPad|iPod|Android/i.test(navigator.userAgent || "");
    if (!isMobile) return;
    try {
      const dismissedAt = parseInt(localStorage.getItem(KEY) || "0", 10);
      const dismissMs = DISMISS_DAYS * 24 * 3600 * 1000;
      if (dismissedAt && Date.now() - dismissedAt < dismissMs) return;
    } catch { /* storage disabled */ }
    setVisible(true);
  }, []);

  const dismiss = () => {
    try { localStorage.setItem(KEY, String(Date.now())); } catch { /* storage disabled */ }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="app-download-banner"
      className="lg:hidden sticky top-0 z-[60] bg-[#0E7A3B] text-white"
    >
      <div className="mx-auto max-w-7xl px-4 py-2 flex items-center gap-3">
        <div className="h-10 w-10 shrink-0 rounded-xl bg-white/15 flex items-center justify-center">
          <Smartphone className="h-5 w-5" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-display font-semibold text-sm leading-tight">
            Ouvrez Zafara dans l'app
          </p>
          <p className="text-xs opacity-85 leading-tight">
            Plus rapide · notifications en direct · paiement en 1 clic
          </p>
        </div>
        <a
          data-testid="app-download-banner-cta"
          href="/api/download"
          className="shrink-0 inline-flex items-center gap-1.5 rounded-full bg-[#F5A800] text-[#16241B] px-4 py-2 text-xs font-bold hover:bg-white transition-colors"
        >
          <Download className="h-3.5 w-3.5" /> Obtenir
        </a>
        <button
          data-testid="app-download-banner-close"
          onClick={dismiss}
          aria-label="Fermer"
          className="shrink-0 h-8 w-8 inline-flex items-center justify-center rounded-full hover:bg-white/15 transition-colors"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};
